export default "__VITE_ASSET__BcHprmk3__"